import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.j47_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.k47_1 = LinkedHashMap().ec();
      }
      l47() {
        return this.k47_1;
      }
      n3y() {
        // Inline function 'kotlin.apply' call
        this.j47_1.n3y();
        return this;
      }
      o3y() {
        // Inline function 'kotlin.apply' call
        this.j47_1.o3y();
        return this;
      }
      f3y() {
        // Inline function 'kotlin.apply' call
        this.j47_1.f3y();
        return this;
      }
      g3y() {
        // Inline function 'kotlin.apply' call
        this.j47_1.g3y();
        return this;
      }
      k4a(name) {
        // Inline function 'kotlin.apply' call
        this.j47_1.k4a(name);
        return this;
      }
      u3y(value) {
        // Inline function 'kotlin.apply' call
        this.j47_1.u3y(value);
        return this;
      }
      e3z(value) {
        // Inline function 'kotlin.apply' call
        this.j47_1.e3z(value);
        return this;
      }
      z3y(value) {
        // Inline function 'kotlin.apply' call
        this.j47_1.z3y(value);
        return this;
      }
      w3y(value) {
        // Inline function 'kotlin.apply' call
        this.j47_1.w3y(value);
        return this;
      }
      c3z(value) {
        // Inline function 'kotlin.apply' call
        this.j47_1.c3z(value);
        return this;
      }
      m4a(value) {
        // Inline function 'kotlin.apply' call
        this.j47_1.m4a(value);
        return this;
      }
      j3z(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.k47_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.j47_1.a4a();
        tmp0.x4(key, value);
        this.j47_1.y3x();
        return this;
      }
      y3x() {
        // Inline function 'kotlin.apply' call
        this.j47_1.y3x();
        return this;
      }
      a4a() {
        return this.j47_1.a4a();
      }
      l6() {
        this.j47_1.l6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
